import React from 'react';
import PropTypes from 'prop-types';
import { NText } from "../../common";
export var ValueGroupHeading = function ValueGroupHeading(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(NText, {
    className: className,
    color: "grey60",
    size: "size6-r",
    "data-t-id": "cards-Values"
  }, children);
};
ValueGroupHeading.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  className: PropTypes.string
} : {};